// extracted by mini-css-extract-plugin
module.exports = {"button":"_333-B_GTirWA5PZ5PeVZS","icon":"_1YN19YCdcoAzURlRJOfDed"};